// extracted by mini-css-extract-plugin
var _1 = "I8N7MbCW";
var _2 = "zaFsx_Og";
var _3 = "zaFsx_Og";
export { _1 as "accordion", _2 as "accordion-group", _3 as "accordionGroup" }
